<div class="feature-section bg-lem-blue-light p-3 rounded-3">
    <h2 class="fs-4 mb-4 fw-semibold text-center">Digitale Drehscheibe (externes Üben)</h2>
    <div #features id="section-external-tools" class="feature-list align-items-start d-flex gap-4 justify-content-center">
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'eduvidual-logo.png' | asset" alt="Feature Eduvidual" />
            <span><strong>Eduvidual Kurse</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar-quicklinks/edusuite-logo.png' | asset" alt="Feature Lemberger Adaptive Mathematik" />
            <span><strong>Lemberger Adaptive Mathematik</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar-quicklinks/esquirrel-logo.png' | asset" alt="Feature eSquirrel" />
            <span><strong>eSquirrel</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar-quicklinks/mathion-logo.png' | asset" alt="Feature Mathion" />
            <span><strong>mathion</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar-quicklinks/matheGym-logo.png' | asset" alt="Feature MatheGym" />
            <span><strong>MatheGym</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar-quicklinks/icon-mathe4alle.png' | asset" alt="Feature mathe4alle" />
            <span><strong>mathe4alle</strong></span>
        </div>
    </div>
</div>